<div
    class="layout-container rx-app-flex-container-row rx-app-flex-container-row--justify-center"
    id="rx-for-lab"
    [ngClass]="(isRxloadedAndReady$ | async) ? 'isVisible' : 'isHidden'"
>
    <div class="lab-container">
        <div class="lab-components-container rx-app-flex-container-column">
            <rx-general-data-v1></rx-general-data-v1>
            <rx-denture-details-info [rx]="rx$ | async" [isResponsive]="true" *ngIf="procedureId$ | async | mapper : isDentureDetailsVisible">
            </rx-denture-details-info>
            <rx-appliance-details-info [rx]="rx$ | async" [isResponsive]="true" *ngIf="isApplianceSectionVisibleForLabs$ | async">
            </rx-appliance-details-info>
			<rx-scan-options-lab [rx]="rx$ | async"></rx-scan-options-lab>
            <div *ngIf="isTeethDiagramAreaVisible$ | async">
                <rx-teeth-diagram-v1></rx-teeth-diagram-v1>
                <rx-treatment-information-v1></rx-treatment-information-v1>
            </div>
            <div *ngIf="isAttachmentsSectionVisible$ | async" class="rx-card" id="attachments-section">
                <div class="rx-card-title">
                    <div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--justify-space-between rx-app-flex-container-row--align-center">{{
                        'AttachmentsSection.Attachments' | translate }}</div>
                </div>
                <div class="rx-card-body">
                    <rx-attachments
                        [rxId]="attachmentsRxId$ | async"
                        [companyId]="companyId$ | async"
                        [contactId]="contactId$ | async"
                        [userRole]="userRole$ | async"
                        [isReadOnly]="isAttachmentsReadOnly$ | async"
                        [biSessionInfo]="biSessionInfo$ | async"
                        [timberUrl]="timberUrl$ | async"
                        (attachmentsListUpdated)="onAttachmentsListUpdated()">
                    </rx-attachments>
                </div>
            </div>
            <ng-content></ng-content>
        </div>
    </div>
</div>
